"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticEventToJSON = exports.DiagnosticEventFromJSONTyped = exports.DiagnosticEventFromJSON = exports.instanceOfDiagnosticEvent = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the DiagnosticEvent interface.
 */
function instanceOfDiagnosticEvent(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDiagnosticEvent = instanceOfDiagnosticEvent;
function DiagnosticEventFromJSON(json) {
    return DiagnosticEventFromJSONTyped(json, false);
}
exports.DiagnosticEventFromJSON = DiagnosticEventFromJSON;
function DiagnosticEventFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'eventCount': !(0, runtime_1.exists)(json, 'event_count') ? undefined : json['event_count'],
        'lastActivityMs': !(0, runtime_1.exists)(json, 'last_activity_ms') ? undefined : json['last_activity_ms'],
    };
}
exports.DiagnosticEventFromJSONTyped = DiagnosticEventFromJSONTyped;
function DiagnosticEventToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'event_count': value.eventCount,
        'last_activity_ms': value.lastActivityMs,
    };
}
exports.DiagnosticEventToJSON = DiagnosticEventToJSON;
